/* eslint-disable standard/computed-property-even-spacing */
import maModal from '@/components/modal'
import maModalPhotoclaim from '@/components/modalPhotoclaim'
import maForm from '@/components/form'
import maButton from '@/components/button-blue'
import maNotifications from '@/components/notifications'
import maSpinner from '@/components/spinner'
import { apiPostImage } from '@/modules/Damage/services/damages/'
import { mapState, mapMutations } from 'vuex'
import { USER_MODULE_NAME } from '@/modules/User/store/types'
import {
  WARRANTY_MODULE_NAME,
  WARRANTY_CLEAR_FORMS,
  WARRANTY_CLEAR_REPORT_MURS,
  WARRANTY_UPDATE_MURS_TOTAL_COUNT
} from '@/store/types'
import flowMixin from '@/modules/Flow/mixins/flowMixin'

import maModalCameraFlow from '@/components/modalCameraFlow'
import maCameraWithSteps from '@/components/cameraComponent/modules/cameraWithSteps'

import { ImageCapture } from 'image-capture'
import { sendPhotoclaimDamages } from '@/modules/Damage/services/damages'
import { apiGetForm } from '@/modules/Damage/services/menus'
import { prepareErrorForSentry } from '@/utils/errorHandling'

const SPACE_PHOTOS = 'space_photos'
const SPACE_MESSAGE = "Enfin, nous avons besoin de 3 photos de l'espace"
const DAMAGES_TYPES = ['PLAF_FXPLAF', 'SOL', '1MUR', 'NETTOYAGE']

export default {
  name: 'photoclaimForm',

  mixins: [flowMixin],

  props: {
    damageReport: {
      required: false,
      type: Object
    },
    pieceId: {
      required: false,
      type: Number | null
    },
    damagedPart: {
      required: false,
      type: Object | null
    },
    allDamagedParts: {
      type: Array,
      default: () => []
    },
    pieceSurface: {
      required: false,
      type: Number | null
    },
    editIndex: {
      required: false,
      type: Number | null,
      default: null
    },
    photosPerDamage: {
      required: false,
      type: Number,
      default: 3
    }
  },

  data: function () {
    return {
      materialOptions: [],
      damageIndex: 0,
      loading: true,
      mediaStream: null,
      constraints: null,
      devicesInput: [],
      imagesInput: [],
      flash: false,
      photoCount: 0,
      photosTotal: 0,
      takingPhoto: false,
      damagedLiteral: null,
      shouldFaceUser: true,
      imageCapture: null
    }
  },

  components: {
    maModal,
    maModalPhotoclaim,
    maForm,
    maButton,
    maNotifications,
    maSpinner,
    maModalCameraFlow,
    maCameraWithSteps
  },

  computed: {
    ...mapState(WARRANTY_MODULE_NAME, {
      stateWarrantyForms: 'forms',
      stateWarrantyCounterMurs: 'counterMurs'
    }),

    ...mapState(USER_MODULE_NAME, {
      stateUserType: 'userType'
    }),

    literalDamagePart() {
      if (
        this.allDamagedParts &&
        this.allDamagedParts.length > 0 &&
        this.damageIndex < this.allDamagedParts.length
      ) {
        return `${this.damagedLiteral} - ${
          this.allDamagedParts[this.damageIndex].literal
        }`
      }

      return `${SPACE_MESSAGE}`
    },

    groups() {
      return this.allDamagedParts ? this.allDamagedParts.length + 1 : 1
    },
    report() {
      return {
        ...this.damageReport
      }
    }
  },

  methods: {
    ...mapMutations(WARRANTY_MODULE_NAME, {
      mutWarrantyClearForms: WARRANTY_CLEAR_FORMS,
      mutWarrantyClearReportMurs: WARRANTY_CLEAR_REPORT_MURS,
      mutStateWarrantyUpdateMursTotalCount: WARRANTY_UPDATE_MURS_TOTAL_COUNT
    }),

    handleCameraPhoto() {
      this.photoCount++
      if (this.photoCount % this.photosPerDamage === 0) {
        this.damageIndex++
      }
    },

    showModalLegacy(damagedLiteral) {
      this.loading = true
      this.spinner = false
      this.damagedLiteral = damagedLiteral
      this.photosTotal =
        this.allDamagedParts.length * this.photosPerDamage +
        this.photosPerDamage

      this.initDamagesProperties()
      this.$refs.modalPhotoclaimForm.showModal = true

      navigator.mediaDevices
        .enumerateDevices()
        .then(this.gotDevices.bind(this))
        .catch((error) => {
          console.log('enumerateDevices() error: ', error)
        })
        .then(this.getStream)
      console.log(navigator)
    },

    showModal(damagedLiteral) {
      this.loading = true
      this.damagedLiteral = damagedLiteral
      this.photosTotal =
        this.allDamagedParts.length * this.photosPerDamage +
        this.photosPerDamage

      this.initDamagesProperties()
      this.$refs.modalPhotoclaimForm.showModal = true
    },

    hideModal() {
      this.resetForms()
      this.loading = false
      this.$refs.modalPhotoclaimForm.showModal = false
    },

    async fileToBase64(file) {
      return new Promise((resolve) => {
        const reader = new FileReader()
        reader.onload = () => resolve(reader.result)
        reader.readAsDataURL(file)
      })
    },

    async saveImage(file) {
      let imageContent
      const imageName = file.name

      const base64img = await this.fileToBase64(file)
      imageContent = base64img.replace(/data:[A-z]*\/[A-z]*;base64,/, '')

      try {
        let imgBody = {
          imageName: `${Date.now()}-${imageName}`,
          imageType: 'photoClaimFlow',
          imageContent: imageContent
        }
        this.imagesInput.push(imgBody)
      } catch (e) {
        this.throwNotification(
          this.$t('notifications.images.uploadError.title'),
          this.$t('notifications.images.uploadError.text'),
          'KO'
        )
        this.resetInputValue()
      }
    },

    async handleChangeInput(e) {
      if (this.photoCount >= this.photosTotal || this.takingPhoto) return

      const fileSize = e.target.files[0].size
      const fileExtension = e.target.files[0].type
      const maxValueFilesize = 6000000
      const acceptedFileExtensions = 'image/jpg , image/jpeg , image/png'
      const fileSizeValidation = fileSize >= maxValueFilesize
      const isAcceptedFileExtension =
        acceptedFileExtensions.includes(fileExtension)

      if (fileSizeValidation || !isAcceptedFileExtension) {
        this.resetInputValue()
      } else {
        await this.saveImage(e.target.files[0])
        this.resetInputValue()
        this.photoCount++

        this.checkTotalPhotos()
      }
    },
    resetInputValue() {
      this.$el.querySelector('input.file').value = null
    },

    /**
     * Checks if required images are uploaded
     */
    checkImages() {
      if (!this.addDamagesHasImages) return true
      return this.imagesInput.length > 0
    },

    /**
     * Checks if the form is valid and sends the updated information to the parent component
     */
    async handleOnAddDamageParts() {
      if (this.checkImages()) {
        try {
          this.loading = true

          const damagePartsPromises = []
          const photoclaimBody = []

          for (const imgBody of this.imagesInput) {
            damagePartsPromises.push(apiPostImage(this.getSinisterId, imgBody))
          }

          const damagesImages = await Promise.all(damagePartsPromises).catch((error) => {
            const context = {
              component: 'photoClaimForm',
              method: 'handleOnAddDamageParts',
              route: this.$route.path
            }

            const tags = prepareErrorForSentry(error, context)

            this.sendSentryError(
              `Error uploading damage part images: ${error.message || 'Unknown error'}`,
              error.response && error.response.status >= 500 ? 'error' : 'warning',
              tags,
              this.getSinisterId,
              'handleOnAddDamageParts'
            )

            this.showImageError
          })

          const lastImgs = damagesImages.slice(-this.photosPerDamage)

          for (const [index, damagedPart] of this.allDamagedParts.entries()) {
            const from = index * this.photosPerDamage
            const to = from + this.photosPerDamage
            const images = damagesImages.slice(from, to)
            const part = {
              images: []
            }
            part.support = damagedPart.key

            for (const { imageURL } of [...images]) {
              part.images.push(imageURL)
            }
            photoclaimBody.push(part)
          }

          const respPhotoclaim = await sendPhotoclaimDamages(
            this.getSinisterId,
            photoclaimBody
          ) //////////////.catch(() => respPhotoclaim = [])

          for (const [index, damagedPart] of this.allDamagedParts.entries()) {
            const from = index * this.photosPerDamage
            const to = from + this.photosPerDamage
            const images = damagesImages.slice(from, to)

            if (!damagedPart.partDamages) damagedPart.partDamages = []
            damagedPart.damagesSended = false

            const photoClaimDamages = respPhotoclaim.find((photoClaimPart) => {
              return photoClaimPart.support === damagedPart.key
            })

            if (photoClaimDamages) {
              for (const damage of photoClaimDamages.photoclaimDamageDescriptionDTO) {
                if (!damage) continue

                const partDamage = {
                  damages: {}
                }

                // Update murs
                if (damagedPart.key.indexOf('MUR') !== -1) {
                  partDamage.damages.QUANTITY = this.stateWarrantyCounterMurs
                }

                partDamage.damages['ROOM_SURFACE'] = this.pieceSurface
                partDamage.damages = {
                  ...partDamage.damages,
                  ...damage.form_info
                }

                const option = this.materialOptions.find(
                  (option) => option.key === partDamage.damages['TYPE_MATERIEL']
                )

                try {
                  const { form } = await apiGetForm(
                    {
                      ...this.report,
                      SUPPORT: damagedPart.key,
                      ...damage.form_info
                    },
                    this.getWarrantyId
                  )
                } catch (error) {
                  const context = {
                    component: 'photoClaimForm',
                    method: 'handleOnAddDamageParts.apiGetForm',
                    route: this.$route.path
                  }

                  const tags = prepareErrorForSentry(error, context)

                  this.sendSentryError(
                    `Error getting form for photoclaim damage: ${error.message || 'Unknown error'}`,
                    error.response && error.response.status >= 500 ? 'error' : 'warning',
                    tags,
                    this.getSinisterId,
                    'handleOnAddDamageParts.apiGetForm'
                  )
                }

                damagedPart.partDamages.push({
                  images: [...images],
                  ...partDamage,
                  description: damage.description,
                  literal: option.literal,
                  damageConfirmed: false,
                  asset_damages: form.asset_damages
                })
              }
            }
          }
          this.$emit('form:allDamagedPartsAdded', {
            pieceType: this.damageReport.PIECE,
            pieceId: this.pieceId,
            damagedParts: this.allDamagedParts,
            spacePhotos: lastImgs
          })

          this.hideModal()
        } catch (error) {
          const context = {
            component: 'photoClaimForm',
            method: 'handleOnAddDamageParts',
            route: this.$route.path
          }

          const tags = prepareErrorForSentry(error, context)

          this.sendSentryError(
            `Error processing damage parts: ${error.message || 'Unknown error'}`,
            error.response && error.response.status >= 500 ? 'error' : 'warning',
            tags,
            this.getSinisterId,
            'handleOnAddDamageParts'
          )
          //this.showImageError()
          ///////////////////////---------------------------------------
          this.$emit('form:allDamagedPartsAdded', {
            pieceType: this.damageReport.PIECE,
            pieceId: this.pieceId,
            damagedParts: this.allDamagedParts,
            spacePhotos: lastImgs
          })
        }
      } else {
        this.showImageError()
      }
    },

    resetFormsLegacy() {
      this.damageIndex = 0
      this.imagesInput = []
      this.mediaStream = null
      this.photoCount = 0
      this.mutWarrantyClearForms()
      this.mutWarrantyClearReportMurs()
      this.stopCameraStream()
    },

    resetForms() {
      this.damageIndex = 0
      this.imagesInput = []
      this.mediaStream = null
      this.photoCount = 0
      this.mutWarrantyClearForms()
      this.mutWarrantyClearReportMurs()
    },

    handlerFlash() {
      if (
        this.imageCapture &&
        this.imageCapture.track.getCapabilities().torch
      ) {
        this.flash = !this.flash
        this.imageCapture.track.applyConstraints({
          advanced: [
            {
              torch: this.flash
            }
          ]
        })
      }
    },

    gotStream(stream) {
      console.log('getUserMedia() got stream: ', stream)
      this.mediaStream = stream
      this.$refs.video.srcObject = stream
      this.imageCapture = new ImageCapture(stream.getVideoTracks()[0])
    },

    stopCameraStream() {
      let tracks =
        this.$refs.video.srcObject && this.$refs.video.srcObject.getTracks()

      if (tracks) {
        tracks.forEach((track) => {
          track.stop()
        })
      }

      if (this.mediaStream) {
        this.mediaStream.getTracks().forEach((track) => {
          track.stop()
        })
      }
    },

    gotDevices(deviceInfos) {
      for (var i = 0; i !== deviceInfos.length; ++i) {
        var deviceInfo = deviceInfos[i]
        console.log('Found media input or output device: ', deviceInfo)

        if (deviceInfo.kind === 'videoinput') {
          this.devicesInput.push(deviceInfo)
        }
      }
      this.loading = false

      const supports = navigator.mediaDevices.getSupportedConstraints()
      if (supports['facingMode'] === true) {
        this.$refs.buttonFlip.disabled = false
      }
    },
    // Get a video stream from the currently selected camera source.
    getStream() {
      if (this.mediaStream) {
        this.mediaStream.getTracks().forEach((track) => {
          track.stop()
        })
      }

      this.constraints = {
        video: {
          facingMode: this.shouldFaceUser ? 'environment' : 'user',
          aspectRatio: { ideal: 1.7777777778 }
        }
      }
      navigator.mediaDevices
        .getUserMedia(this.constraints)
        .then(this.gotStream)
        .catch((error) => {
          console.log('getUserMedia error: ', error)
        })
    },

    flipCamera() {
      if (this.mediaStream == null) return
      // we need to flip, stop everything
      this.mediaStream.getTracks().forEach((t) => {
        t.stop()
      })
      // toggle / flip
      this.shouldFaceUser = !this.shouldFaceUser
      this.getStream()
    },

    async blobToBase64(blob) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onloadend = () => resolve(reader.result)
        reader.readAsDataURL(blob)
      })
    },

    async setBlobImage(blob) {
      const base64img = await this.blobToBase64(blob)
      const [, ext] = base64img.split(';')[0].split('/')

      const imageContent = base64img.replace(/data:[A-z]*\/[A-z]*;base64,/, '')

      try {
        console.log(this.damageIndex)
        const photoName =
          this.damageIndex < this.allDamagedParts.length
            ? this.allDamagedParts[this.damageIndex].key.toLowerCase()
            : SPACE_PHOTOS
        let imgBody = {
          imageName: `${photoName}_${new Date().getTime()}.${ext}`,
          imageType: 'photoClaimFlow',
          imageContent: imageContent
        }
        // const res = await apiPostImage(this.getSinisterId, imgBody)
        this.imagesInput.push(imgBody)
        /*     this.$refs.img.classList.remove('hidden')
        this.$refs.img.src = URL.createObjectURL(blob) */
      } catch (e) {
        console.log(e)
        this.throwNotification(
          this.$t('notifications.images.uploadError.title'),
          this.$t('notifications.images.uploadError.text'),
          'KO'
        )
      }
    },

    async takePhoto() {
      if (
        (this.imageCapture && this.photoCount >= this.photosTotal) ||
        this.takingPhoto
      ) {
        return
      }

      this.takingPhoto = !this.takingPhoto

      // eslint-disable-next-line promise/param-names
      const blob = await new Promise(async (res) => {
        const blobResp = await this.imageCapture
          .takePhoto()
          .catch(function (error) {
            console.log('takePhoto() error: ', error)
          })
        setTimeout(() => res(blobResp), 1500)
      })

      await this.setBlobImage(blob)

      this.photoCount++
      this.takingPhoto = !this.takingPhoto

      this.checkTotalPhotos()
    },

    async checkTotalPhotos() {
      if (
        this.photoCount % this.photosPerDamage === 0 &&
        this.photoCount !== this.photosTotal
      ) {
        this.damageIndex++
      }

      if (this.photoCount === this.photosTotal) {
        let tracks =
          this.$refs.video.srcObject && this.$refs.video.srcObject.getTracks()
        console.log(tracks)
        if (tracks) {
          tracks.forEach((track) => {
            track.stop()
          })
        }
        this.loading = true
        await this.handleOnAddDamageParts()
      }
    },

    async initDamagesProperties() {
      const damageFormsPromises = []

      DAMAGES_TYPES.forEach((key) => {
        damageFormsPromises.push(
          apiGetForm(
            {
              ...this.report,
              SUPPORT: key
            },
            this.getWarrantyId
          )
        )
      })

      const forms = await Promise.all(damageFormsPromises).catch(
        (error) => {
          const context = {
            component: 'photoClaimForm',
            method: 'initDamagesProperties',
            route: this.$route.path
          }

          const tags = prepareErrorForSentry(error, context)

          this.sendSentryError(
            `Error initializing damage properties: ${error.message || 'Unknown error'}`,
            error.response && error.response.status >= 500 ? 'error' : 'warning',
            tags,
            this.getSinisterId,
            'initDamagesProperties'
          )

          this.materialOptions = []
        })

      for (const { form } of forms) {
        const options = form.regions.find(
          (region) => region.name === 'GEN_IMMO_UNI'
        )

        if (options) {
          const materialInput = options.inputs.find(
            (input) => input.name === 'TYPE_MATERIEL'
          )

          if (materialInput) {
            this.materialOptions.push(...materialInput.options)
          }
        }
      }

      this.loading = false // Importan remove to work with the legacy mode
    },

    /**
     * New way to take photos
     */

    prepareImagesBody(photos) {
      const imagesBody = []

      for (let [index, imgBase64] of photos.entries()) {
        const [, ext] = imgBase64.split(';')[0].split('/')
        const imageContent = imgBase64.replace(
          /data:[A-z]*\/[A-z]*;base64,/,
          ''
        )
        const photoName =
          index < this.allDamagedParts.length - 3 ? index : SPACE_PHOTOS
        let imgBody = {
          imageName: `${photoName}_${new Date().getTime()}.${ext}`,
          imageType: 'photoClaimFlow',
          imageContent: imageContent
        }
        imagesBody.push(imgBody)
      }

      return imagesBody
    },

    async handlePhotos(photos) {
      this.imagesInput.push(...this.prepareImagesBody(photos))
      await this.handleOnAddDamageParts()
    },

    showImageError() {
      this.loading = false
      this.hideModal()
      this.throwNotification(
        this.$t('claim.details.errorImages'),
        this.$t('claim.details.errorImages'),
        'KO'
      )
    }
  }
}
